import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import { ToastService } from 'src/app/core';
import { AuthService } from 'src/app/core/auth.service';
import { DialogService } from 'src/app/core/dialog.service';
import { LoaderService } from 'src/app/core/loader.service';
import { Activity, ActivityStatus, CandidateApi, CandidateProfile, Comments, CommentsApi, PBApi } from '../../core/api.gen';
import { CommentTypes } from '../comment-types';

@Component({
  selector: 'eos-comment',
  templateUrl: './comment.component.html',
})
export class CommentComponent implements OnInit {

  @Input() public readonly?: boolean;
  @Input() public commentType: number;
  @Input() public candidate: CandidateProfile;

  comments: Comments[] = [];
  activity: Activity;
  IsActivityComment: boolean;
  IsSingleCommentAdded: boolean;
  onSubmit: Function;
  editMode = false;
  commentId: number;
  employeeId: number;
  noteComment = CommentTypes.ProfileNotes;
  addclicked = false;
  isPendingComment = false;
  commentForm = new UntypedFormGroup({
    comment: new UntypedFormControl('', [Validators.required]),
    candidateProfileId: new UntypedFormControl(0),
    commentType: new UntypedFormControl(null),
    statusId: new UntypedFormControl(null),
    Id: new UntypedFormControl(null)
  });
 

  constructor(
    public modal: NgbActiveModal,
    private commentService: CommentsApi,
    private toast: ToastService,
    private pbAPI: PBApi,
    private authService: AuthService,
    private loader: LoaderService,
    private dialog: DialogService,
    private candidateApi: CandidateApi  ) { }

  ngOnInit() {
    this.IsSingleCommentAdded = false;
    this.employeeId = this.authService.ActiveUser.employeeId;
    this.getComments();
    this.candidateApi.checkAccess(this.candidate.id,true).subscribe(resp => {
      this.isPendingComment = resp;
      
      });
  }

  getComments() {
    this.commentService.getCommentsAndNotes(this.candidate.id, CommentTypes.Preboarding).subscribe(resp => {

      this.comments = resp.filter(x => x.commentType != -2);
      if (this.comments.some(x => x.comment.includes('•'))) {
        this.commentForm.patchValue({ comment: "•	\n•	\n•	\n•	" }); //bullet points
      }
      else {
        this.commentForm.patchValue({ comment: resp.find(x => x.commentType == -2).comment });

      }
      


    });
  }

  get DisableSaveUpdate(): boolean {
    return !this.commentForm.valid || this.readonly || this.addclicked;
  }

  save() {
    this.dialog.showCommentConfirmationBox('Confirm mail trigger',
    `Do you want to notify this comment to recruiter, HM and AM?`,
    () => {
     this.savecomment(true);
    },
    () => {
      this.savecomment(false);
    })  
  }

  savecomment(isMailConfirm:boolean ){

    this.commentForm.patchValue({
      commentType: this.commentType,
      statusId: this.candidate.status.id,
      candidateProfileId: this.candidate.id,
      comment: this.commentForm.value.comment.trim(),
      Id: this.commentId
    });

    if (this.commentForm.value.comment.trim() !== '') {
      this.addclicked = true;
      this.loader.show();
      this.commentService.save(isMailConfirm,this.commentForm.getRawValue())
        .pipe(finalize(() => {
          this.loader.clear();
          if (!this.editMode) {
            this.toast.success("Successfully saved!");
          } else {
            this.toast.success("Successfully updated!");
          }
          this.IsSingleCommentAdded = true;
          this.editMode = false;
          this.commentForm.patchValue({ comment: ''});
          this.commentId = 0;
          this.addclicked = false;
        }))
        .subscribe(resp => {
          this.getComments();
        });
    }
  }

  UpdateCurrentDT() {
    this.editComment(this.comments[0]);
    this.savecomment(false);
  }

  onCommentSubmit() {
    if (this.IsActivityComment) {
      this.updateActivity().subscribe((result) => {
      this.toast.success("Activity completed");
      this.modal.close();
      this.onSubmit(result.completedDate);
    });
  }
  }

  editComment(comm: Comments) {
    this.editMode = true;
    this.commentForm.value.comment = comm.comment;
    this.commentType = comm.commentType;
    this.candidate.status.id = comm.statusId;
    this.candidate.id = comm.candidateProfileId;
    this.commentId = comm.id;

    this.commentForm.patchValue({
      commentType: comm.commentType,
      statusId: comm.statusId,
      candidateProfileId: comm.candidateProfileId,
      comment: comm.comment,
      Id: comm.id
    });
  }

  updateActivity() {
    return this.pbAPI.updateCandidateActivity(this.candidate.id, this.activity.id, ActivityStatus.Done);
  }
}
